import { getRequest } from './base';

const getFeatureFlags = async () => {
  const data = await getRequest('/features');

  return data.data;
};

export default getFeatureFlags;
